var path = 'public/app/plugins/panel/experimentdetails/module.html';
var html = "\n<style>.experimentlabel{font-weight:700}</style>\n\n<div style=overflow:scroll;height:100%>\n    \n    <br>\n    <h3>{{ ctrl.experiment.title }}</h3>\n\n    <br><span class=experimentlabel>Created:</span> {{ ctrl.experiment.created }}\n    <br><span class=experimentlabel>Duration:</span> {{ ctrl.experiment.duration.toFixed(1) }}s\n    <br><span class=experimentlabel>Notes:</span> \n    <span style=white-space:pre-wrap>{{ ctrl.experiment.notes }}</span>\n\n    <br>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/plugins/panel/experimentdetails/module.html
// module id = 1151
// module chunks = 3